export default __webpack_public_path__ + "static/media/preferred-social-channels.png";